import { render, staticRenderFns } from "./StudentDetails.vue?vue&type=template&id=89b0220c&scoped=true&"
import script from "./StudentDetails.vue?vue&type=script&lang=js&"
export * from "./StudentDetails.vue?vue&type=script&lang=js&"
import style0 from "./StudentDetails.vue?vue&type=style&index=0&id=89b0220c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b0220c",
  null
  
)

export default component.exports